export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-paper-100">
      {/* 背景大图 + 遮罩 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Traditional%20Chinese%20fantasy%20yokai%20manga%20hero%20scene%20with%20nine%20tailed%20fox%20moonlit%20pagoda%20and%20floating%20paper%20lanterns%2C%20cinnabar%20red%20gold%20and%20dark%20teal%20ink%20painting%20style%2C%20misty%20mountains%2C%20dreamy%20ethereal%20atmosphere%2C%20dramatic%20wide%20composition&width=1600&height=900&seq=hero-main-01&orientation=landscape"
          alt="妖精漫画大全首屏背景：月下狐妖与灯火古塔"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-900/70 via-ink-900/45 to-ink-900/70"></div>
      </div>

      <div className="relative mx-auto flex min-h-[600px] w-full max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:min-h-[640px] md:px-6 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-300/60 bg-accent-500/20 px-4 py-1.5 text-sm text-accent-100 backdrop-blur-sm">
          <i className="ri-sparkling-line" aria-hidden="true"></i>
          狐妖 · 猫妖 · 花妖 · 百妖志怪一网打尽
        </span>

        <h1 className="mt-6 font-serif text-4xl font-bold leading-tight text-paper-50 md:text-6xl">
          妖精漫画大全
        </h1>
        <p className="mt-3 font-serif text-lg text-accent-200 md:text-2xl">
          点开即看 · 更新快 · 无需下载
        </p>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-paper-100/90 md:text-lg">
          妖精漫画大全免费在线看，收录狐妖、猫妖、花妖、树妖、雪女、河童等全类型妖精漫画。
          这里有全集与合集资源，热门冷门都能翻到，找妖精漫画大全网站入口，就上这里。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#categories"
            className="whitespace-nowrap rounded-full bg-primary-500 px-8 py-3 text-base text-paper-50 transition-colors hover:bg-primary-600"
          >
            浏览全部类型
          </a>
          <a
            href="#collection"
            className="whitespace-nowrap rounded-full border border-paper-100/70 bg-paper-50/10 px-8 py-3 text-base text-paper-50 backdrop-blur-sm transition-colors hover:bg-paper-50/20"
          >
            进入大全合集
          </a>
        </div>

        {/* 数据统计 */}
        <dl className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-3 md:gap-6">
          {[
            { num: '1200+', label: '收录作品' },
            { num: '6+', label: '妖精类型' },
            { num: '日更', label: '连载同步' },
          ].map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center rounded-2xl border border-paper-100/20 bg-ink-900/30 px-3 py-5 backdrop-blur-sm"
            >
              <dd className="font-serif text-2xl font-bold text-accent-300 md:text-3xl">{item.num}</dd>
              <dt className="mt-1 text-sm text-paper-100/80">{item.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}